// Мэдэгдлийн хонх (эцэг эх) — уншаагүйн тоо, жагсаалт; дарвал уншсан болгож холбоос руу нь орно
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Badge, Dropdown, Spin } from "antd";
import { FiBell } from "react-icons/fi";
import dayjs from "dayjs";
import { instance } from "utils/axios";

function Notifications() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({ unread: 0, items: [] });
  const [loading, setLoading] = useState(false);

  const load = () => {
    setLoading(true);
    instance({ method: "get", url: "/notifications", params: { limit: 30 } })
      .then((res) => res.data && setData(res.data))
      .catch(() => {})
      .then(() => setLoading(false));
  };
  useEffect(() => { load(); }, []);

  const markRead = (id) => instance({ method: "post", url: `/notifications/${id}/read`, silent: true }).catch(() => {});

  const onItem = (n) => {
    if (!n.readAt) {
      markRead(n.id);
      setData((d) => ({
        unread: Math.max(0, d.unread - 1),
        items: d.items.map((x) => (x.id === n.id ? { ...x, readAt: new Date().toISOString() } : x)),
      }));
    }
    setOpen(false);
    if (!n.url) return;
    if (/^https?:\/\//.test(n.url)) window.open(n.url, "_blank", "noopener");
    else navigate(n.url);
  };
  const readAll = () => {
    markRead("all");
    const now = new Date().toISOString();
    setData((d) => ({ unread: 0, items: d.items.map((x) => ({ ...x, readAt: x.readAt || now })) }));
  };

  const panel = (
    <div className="pcard w-[340px] max-w-[calc(100vw-24px)] overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <span className="text-sm font-bold text-gray-900">Мэдэгдэл</span>
        {data.unread > 0 && (
          <button onClick={readAll} className="text-xs font-semibold text-primary">Бүгдийг уншсан</button>
        )}
      </div>
      <div className="max-h-[60vh] overflow-y-auto divide-y divide-gray-50">
        {loading && !data.items.length ? (
          <div className="flex justify-center py-8"><Spin size="small" /></div>
        ) : data.items.length ? data.items.map((n) => (
          <button key={n.id} onClick={() => onItem(n)} className={`w-full text-left flex gap-2.5 px-4 py-3 hover:bg-gray-50 ${n.readAt ? "" : "bg-primary/5"}`}>
            <span className={`h-2 w-2 rounded-full mt-1.5 shrink-0 ${n.readAt ? "bg-transparent" : n.level === "important" ? "bg-red-500" : "bg-primary"}`} />
            <span className="flex-1 min-w-0">
              <span className={`block text-sm leading-snug ${n.readAt ? "font-medium text-gray-700" : "font-bold text-gray-900"}`}>{n.title}</span>
              {n.body && <span className="block text-xs text-gray-500 mt-0.5 line-clamp-2">{n.body}</span>}
              <span className="block text-[11px] text-gray-400 mt-1">{dayjs(n.createdAt).format("MM/DD HH:mm")}</span>
            </span>
          </button>
        )) : (
          <div className="text-center text-sm text-gray-400 py-8">Мэдэгдэл алга</div>
        )}
      </div>
    </div>
  );

  return (
    <Dropdown open={open} onOpenChange={(v) => { setOpen(v); if (v) load(); }} trigger={["click"]} placement="bottomRight" dropdownRender={() => panel}>
      <button aria-label="Мэдэгдэл" className="h-10 w-10 rounded-full flex items-center justify-center text-gray-600 hover:bg-gray-100 transition-colors">
        <Badge count={data.unread} size="small" offset={[-2, 2]}>
          <FiBell size={20} className="text-gray-600" />
        </Badge>
      </button>
    </Dropdown>
  );
}

export default Notifications;
